import type { GhostPost } from "../../types";

const STEP_MAX_POSTS = 10;

interface ShowMoreButtonProps {
  posts: GhostPost[];
  maxPosts: number;
  setMaxPosts: (n: number) => void;
}

export default function ShowMoreButton({
  posts,
  maxPosts,
  setMaxPosts,
}: ShowMoreButtonProps) {
  if (!posts?.length || maxPosts >= posts?.length) {
    return null;
  }
  return (
    <button
      className="w-full my-3 p-[1rem] border border-neutral-200 hover:border-neutral-300 text-neutral-800 hover:text-black font-semibold rounded transition duration-150 ease hover:ease"
      onClick={() => setMaxPosts(maxPosts + STEP_MAX_POSTS)}
    >
      Show more results
    </button>
  );
}
